import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

/**
 * @param {{
 *    className?: string
 * }} props
 * @returns {React.Component}
 */
const ZariPortlet = ({ className, noBg, ...props }) => {
  return (
    <div
      {...props}
      className={clsx(
        'zr-portlet kt-portlet',
        {
          'no-bg': noBg
        },
        className
      )}
    />
  )
}

ZariPortlet.propTypes = {
  className: PropTypes.string
}

export default ZariPortlet
